import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import axios from "axios";
import reportWebVitals from "./reportWebVitals";
import { ApolloProvider } from "@apollo/client";
import Bugsnag from "@bugsnag/js";
import i18n from "./i18next";
import clientV3 from "./apolloClient";
import "./i18next";
import VConsole from "./assets/vconsole.min.js";
// Optimized font loading - only import specific weights needed
import "@fontsource/roboto/300.css?display=swap"; // Light weight
import "@fontsource/roboto/400.css?display=swap"; // Regular weight
import "@fontsource/roboto/500.css?display=swap"; // Medium weight
import "@fontsource/roboto/700.css?display=swap"; // Bold weight
import "@fontsource/poppins/400.css?display=swap"; // Regular weight
import "@fontsource/poppins/700.css?display=swap"; // Bold weight
import { isAuthenticated } from "./lib/auth.js";
import { setLogVerbosity } from "@apollo/client";

setLogVerbosity("error");
require("./utils/js-sdk.min.js");

const originalAddEventListener = EventTarget.prototype.addEventListener;
EventTarget.prototype.addEventListener = function (type, listener, options) {
  if (type === "touchstart" || type === "touchmove" || type === "wheel") {
    options = { passive: true, ...(options || {}) };
  }
  originalAddEventListener.call(this, type, listener, options);
};

if (
  window.location.href.includes("miniapp") &&
  isAuthenticated() &&
  localStorage.getItem("identifier") === "kaungb2c@gmail.com"
) {
  new VConsole();
}

const isTbtDebugEnabled =
  typeof window !== "undefined" &&
  new URLSearchParams(window.location.search).get("tbt_debug") === "1";

if (
  isTbtDebugEnabled &&
  typeof window !== "undefined" &&
  typeof PerformanceObserver !== "undefined"
) {
  const longTasks = [];
  const webVitals = {
    lcp: null,
    cls: 0,
    inp: null,
  };

  let longTaskObserver;
  let lcpObserver;
  let clsObserver;
  let eventObserver;

  try {
    longTaskObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        longTasks.push({
          start: Number(entry.startTime.toFixed(1)),
          duration: Number(entry.duration.toFixed(1)),
        });
      });
    });
    longTaskObserver.observe({ type: "longtask", buffered: true });
  } catch (error) {
    // Observer not supported in this browser.
  }

  try {
    lcpObserver = new PerformanceObserver((list) => {
      const entries = list.getEntries();
      const lastEntry = entries[entries.length - 1];
      if (lastEntry) {
        webVitals.lcp = Number(lastEntry.startTime.toFixed(1));
      }
    });
    lcpObserver.observe({ type: "largest-contentful-paint", buffered: true });
  } catch (error) {
    // Observer not supported in this browser.
  }

  try {
    clsObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (!entry.hadRecentInput) {
          webVitals.cls += entry.value || 0;
        }
      });
    });
    clsObserver.observe({ type: "layout-shift", buffered: true });
  } catch (error) {
    // Observer not supported in this browser.
  }

  try {
    eventObserver = new PerformanceObserver((list) => {
      list.getEntries().forEach((entry) => {
        if (
          entry.name === "click" &&
          (!webVitals.inp || entry.duration > webVitals.inp)
        ) {
          webVitals.inp = Number(entry.duration.toFixed(1));
        }
      });
    });
    eventObserver.observe({
      type: "event",
      buffered: true,
      durationThreshold: 40,
    });
  } catch (error) {
    // Observer not supported in this browser.
  }

  const printPerfDebug = () => {
    const totalBlockingTime = longTasks.reduce((sum, task) => {
      return sum + Math.max(0, task.duration - 50);
    }, 0);

    console.group("[Perf Debug] Global");
    console.log("URL:", window.location.href);
    console.log("Long tasks count:", longTasks.length);
    console.log("Estimated TBT (ms):", Number(totalBlockingTime.toFixed(1)));
    console.log("LCP (ms):", webVitals.lcp ?? "n/a");
    console.log("CLS:", Number(webVitals.cls.toFixed(4)));
    console.log("INP-like max event duration (ms):", webVitals.inp ?? "n/a");
    console.table(longTasks.slice(0, 30));
    console.groupEnd();
  };

  window.addEventListener(
    "load",
    () => {
      setTimeout(printPerfDebug, 10000);
    },
    { once: true },
  );
}
const root = ReactDOM.createRoot(document.getElementById("root"));

axios.defaults.baseURL = process.env.REACT_APP_BASE_URL;
i18n.changeLanguage(
  window.location.href.split("/")[3] === "my-mm" ? "my" : "en",
);

axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response;
  },
  function (error) {
    // Do something with response error
    Bugsnag.notify(error);
    return Promise.reject(error);
  },
);

// if (window.location.pathname.includes("in-web")) {
//   let script = document.createElement("script");
//   script.setAttribute("src", "https://plausible.io/js/plausible.js");
//   script.setAttribute("type", "text/javascript");
//   script.setAttribute("data-domain", "flymya.com");
//   document.head.appendChild(script);
// }
root.render(
  <ApolloProvider client={clientV3()}>
    <App />
  </ApolloProvider>,
);

window.addEventListener("error", (event) => {
  if (event.message.includes("t.maskResult is not a function")) {
    console.warn("Suppressed error:", event.message);
    event.preventDefault(); // Prevent the error from showing in the console
  }
});
function updateFooterPosition() {
  const footer = document.getElementById("#footerMenu");
  if (footer)
    footer.style.bottom = `${
      window.innerHeight - document.documentElement.clientHeight
    }px`;
}

window.addEventListener("resize", updateFooterPosition);
updateFooterPosition();
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
